import React from "react";
import { Link } from "react-router-dom";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../../components/Component";

const p = process.env.PUBLIC_URL || "";

const cards = [
  {
    title: "Inspections & planification",
    text: "Checklists récurrentes, brouillons automatiques, scoring et non-conformités reliées aux observations.",
    to: `${p}/hse-process/inspections`,
    icon: "notes-alt",
    accent: "primary",
  },
  {
    title: "Permis de travail (PTW)",
    text: "Travaux à risque : validation hiérarchique avant l’intervention — le risque est traité avant l’exécution.",
    to: `${p}/hse-process/permits`,
    icon: "shield-check",
    accent: "success",
  },
  {
    title: "Management of Change (MOC)",
    text: "Changements maîtrisés : analyse d’impact et validations avant mise en œuvre.",
    to: `${p}/hse-process/moc`,
    icon: "swap-alt",
    accent: "info",
  },
  {
    title: "Actifs & sécurité",
    text: "Registre équipement, historique et score de risque — lien avec inspections et incidents.",
    to: `${p}/hse-process/assets`,
    icon: "grid-alt",
    accent: "warning",
  },
  {
    title: "Observations HSE",
    text: "Terrain : positif, presqu’accident, non-conformité — workflow de traitement et traçabilité.",
    to: `${p}/observations`,
    icon: "file-text",
    accent: "secondary",
  },
  {
    title: "Incidents & RCA",
    text: "Dernière ligne : enquête structurée (5 Pourquoi, Ishikawa, CAPA). À utiliser quand la prévention n’a pas suffi.",
    to: `${p}/hse-process/incidents`,
    icon: "alert-circle",
    accent: "danger",
  },
];

const HseProcessOverviewPage = () => {
  return (
    <React.Fragment>
      <Head title="Processus HSE — vue d’ensemble" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Processus HSE — prévention & continuité</BlockTitle>
              <BlockDes className="text-soft">
                <p className="mb-2">
                  Cette vue regroupe les modules autour d’une même idée : <strong>anticiper</strong> (inspections, PTW, MOC,
                  observations), <strong>relier les données</strong> (inspection → observation → actif), et{" "}
                  <strong>verrouiller les étapes</strong> côté serveur lorsque c’est pertinent (workflow incidents, soumission
                  d’inspection, permis).
                </p>
                <p className="mb-0 small">
                  Parcours type : planifier / inspecter → corriger via observations → n’ouvrir un incident RCA qu’en cas
                  d’événement réel ou de politique d’entreprise exigeant une enquête formelle.
                </p>
              </BlockDes>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="row g-gs">
            {cards.map((c) => (
              <div key={c.to} className="col-md-6 col-xl-4">
                <div className={`card card-bordered h-100 border-${c.accent}`}>
                  <div className="card-inner">
                    <div className="d-flex align-items-start mb-2">
                      <Icon name={c.icon} className={`fs-3 text-${c.accent}`} />
                      <div className="flex-grow-1">
                        <h6 className="title mb-1">{c.title}</h6>
                        <p className="text-soft small mb-3">{c.text}</p>
                        <Link to={c.to} className={`btn btn-dim btn-${c.accent}`}>
                          Ouvrir
                          <Icon name="chevron-right" className="ms-1" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default HseProcessOverviewPage;
